/* Model */
class MapConfigurationModel extends App.Models.BaseModel {
    modelUrl = 'MapConfiguration';
}

App.Models.MapConfiguration = MapConfigurationModel;

/* Collection */
class MapConfigurationCollection extends App.Collections.BaseCollection {
    url = 'MapConfiguration';
    model = App.Models.MapConfiguration;
}

App.Collections.MapConfigurations = MapConfigurationCollection;

/* Router */
class MapConfigurationRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'MapConfiguration';
        const model = App.Models.MapConfiguration;
        const collectionClass = App.Collections.MapConfigurations;

        super(entityName, model, collectionClass);
    }
}

App.Routers.MapConfiguration = MapConfigurationRouter;
